import Dialog from "src/components/Dialog";
import { useTranslation } from "react-i18next";

export default function InvalidCredentialsDialog({ onDismiss, isOpen }) {
  const { t } = useTranslation();
  return (
    <Dialog
      isOpen={isOpen}
      heading={t("auth.invalidCredentialsDialog.heading")}
      text={t("auth.invalidCredentialsDialog.text")}
      type="failure"
      buttons={[{ text: t("buttons.ok"), onClick: onDismiss }]}
    />
  );
}
